<template>
  <b-modal ref="modal" size="xl" body-class="modal-body-custom" class="user-verification-modal" hide-footer hide-header>
    <b-form @submit.prevent="yesAction">
      <b-container fluid>
        <b-row class="text-center">
          <b-col>
            <h5 class="mb-24">{{ modalData.title }}</h5>
            <div class="pb-40">
              <p class="mb-0 color_00" v-html="modalData.desc" />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-form-group class="group input-group d-flex flex-column position-relative mt-40" :invalid-feedback="errors.first('username')" :state="veeFields.username && veeFields.username.touched && veeFields.username.validated ? !errors.has('username') : null">
            <b-form-input v-if="awsCognitoAuthentication && awsCognitoAuthentication === true" v-validate="'required'" v-model.trim="userCredentials.username" id="username" name="username" placeholder="Username" :state="veeFields.username && veeFields.username.touched && veeFields.username.validated ? !errors.has('username') : null" @change="veeFields.username.touched = true"></b-form-input>
            <b-form-input v-else v-validate="'required|email'" v-model.trim="userCredentials.username" id="username" name="username" placeholder="Username" :state="veeFields.username && veeFields.username.touched && veeFields.username.validated ? !errors.has('username') : null" @change="veeFields.username.touched = true"></b-form-input>

            <label for="username" class="input-label">
              {{ awsCognitoAuthentication && awsCognitoAuthentication === true ? "Username" : "Email" }}
            </label>
          </b-form-group>
        </b-row>
        <b-row>
          <b-form-group class="mt-16 group d-flex flex-column input-group position-relative" :invalid-feedback="errors.first('password')" :state="veeFields.password && veeFields.password.touched && veeFields.password.validated ? !errors.has('password') : null">
            <b-form-input id="password" name="password" type="password" placeholder="Password" :state="veeFields.password && veeFields.password.touched && veeFields.password.validated ? !errors.has('password') : null" v-model.trim="userCredentials.password" v-validate="'required'" @change="veeFields.password.touched = true"></b-form-input>
            <label for="password" class="input-label">Password</label>
          </b-form-group>
        </b-row>
        <div class="text-center mt-48 input-group d-flex flex-column justify-content-center">
          <b-button type="submit" :disabled="errors.any() || isSigning" class="save-btn">
            {{ modalData.submitBtnText }}
          </b-button>
          <b-button class="mt-16 mb-24 cancel-button" @click="hide">
            {{ modalData.cancelBtnText }}
          </b-button>
        </div>
      </b-container>
    </b-form>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import localStorageService from "@/services/localStorage";
const jwtDecode = require("jwt-decode");

export default {
  name: "UserVerificationModal",
  props: {
    userDetails: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    userCredentials: {
      username: "",
      password: ""
    },
    modalData: {
      title: "Review Participant",
      desc: `I hereby confirm the completeness and correctness of all data entered within this document by applying an electronic signature,
            using my account username and password. This electronic signature is the legally binding equivalent of my handwritten signature.
            I understand that this electronic signature is assigned only to my account username and password; 
            no other person is authorized to use my account information.<br /><br />Please enter your username and password to sign this document.`,
      submitBtnText: "Yes, review",
      cancelBtnText: "No, do not review"
    },
    resolve: null,
    reject: null,
    isSigning: false
  }),

  computed: {
    ...mapGetters(["user", "awsCognitoAuthentication"])
  },

  methods: {
    ...mapActions(["userLogin"]),

    open(title, desc, submitBtnText, cancelBtnText) {
      if (!!title && !!desc && !!submitBtnText && !!cancelBtnText) {
        this.modalData = Object.assign(this.modalData, {
          title,
          desc,
          submitBtnText,
          cancelBtnText
        });
      }
      this.resetFields();
      this.$refs.modal.show();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    hide() {
      this.reject(true);
      this.resetFields();
      this.$refs.modal.hide();
    },

    resetFields() {
      this.userCredentials = Object.assign({}, { username: "", password: "" });
      this.veeFields.username.touched = false;
      this.veeFields.password.touched = false;
    },

    async yesAction() {
      if (
        !this.errors.any() &&
        ((this.awsCognitoAuthentication && this.awsCognitoAuthentication === true && this.user.cognitoUsername.toUpperCase().trim() === this.userCredentials.username.toUpperCase().trim()) ||
          ((!this.awsCognitoAuthentication || this.awsCognitoAuthentication === false) &&
            this.getUserDetails("username")
              .toUpperCase()
              .trim() === this.userCredentials.username.toUpperCase().trim()))
      ) {
        try {
          this.isSigning = true;
          this.userCredentials.electronicSignatureSignIn = "YES";

          await this.userLogin(this.userCredentials);
          this.resolve(true);
          this.$refs.modal.hide();
        } catch (error) {
          this.$toastr.error("Unable to verify email and/or password.");
        } finally {
          this.isSigning = false;
        }
      } else {
        // If Username/Email is not same as the loggedin PI, comparison failed with vuex data
        this.$toastr.error("You do not have access rights to approve participant responses.");
      }
    },
    getUserDetails(userData) {
      const token = localStorageService.getItem("token");
      const tokenObj = jwtDecode(token);
      if (this.user && this.user[userData]) {
        return this.user[userData];
      } else if (this.userDetails && this.userDetails[userData]) {
        return this.userDetails[userData];
      } else if (tokenObj && tokenObj[userData]) {
        return tokenObj[userData];
      } else {
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.user-verification-modal {
  .modal {
    .modal-body {
      &.modal-body-custom {
        h5 {
          color: #4a4a4a;
        }

        p {
          line-height: normal;
          letter-spacing: normal;
        }

        .input-group {
          max-width: 541px;
          margin: auto;
          width: 100%;

          div {
            width: 100%;
          }

          input {
            background-color: transparent !important;
            border-radius: 4px;
            font-size: 16px;
            line-height: 1.5;
            padding: 5px 12px;
            z-index: 1;
            caret-color: #83c6a8;
            color: #4a4a4a;
            position: relative;

            &::-webkit-input-placeholder {
              opacity: 0;
            }

            &:focus,
            &:not(:placeholder-shown),
            &.is-valid {
              border-color: #83c6a8;
              box-shadow: none;

              + {
                label {
                  top: -6px;
                  font-size: 12px;
                  background: #fff;
                  z-index: 3;
                  color: #83c6a8;
                }
              }
            }

            &.is-invalid {
              border-color: #dc3545;
              caret-color: #dc3545;

              + label {
                color: #dc3545;
              }
            }
          }

          label {
            background: #ffffff;
            height: 12px;
            left: 15px;
            line-height: 12px;
            margin: 0;
            position: absolute;
            top: 12px;
            transition: 0.2s;
            width: auto;
            z-index: 0;
          }
        }

        button {
          border: 0px;
          border-radius: 4px;
          font-size: 14px;
          padding: 0.469rem 0.75rem;

          &.save-btn {
            background-color: #4c8ce4;
          }
          &.cancel-button {
            background-color: #e0e0e0;
            color: #4a4a4a;
          }
        }
      }
    }
  }
}
</style>
